import { ContentService } from '@blk/cwp-ng-framework';
import * as dayjs from 'dayjs';
import * as isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import * as quarterOfYear from 'dayjs/plugin/quarterOfYear';

import { DateFormatter } from './date-formatter';
import { Formatter } from './formatter.interface';

dayjs.extend(isSameOrBefore);
dayjs.extend(quarterOfYear);

/**
 * Formatter used for finding the most recent quarter end based on a provided date
 * If the date itself is a quarter end, then it will remain unchanged and be formatted normally,
 * otherwise, the previous quarter end will be returned, using the provided formatting.
 */
export class LastQuarterEndDateFormatter implements Formatter {
	constructor(public readonly pattern?: string, private defaultValue?: string, private isDateString: boolean = false) { }
	public format(value: any, contentSvc?: ContentService): string {
		let quarterEnd: string = value;
		if (!!value) {
			const currentQuarterEnd: string = dayjs(value).endOf('quarter').format('YYYY-MM-DD');

			if (dayjs(currentQuarterEnd).isSameOrBefore(dayjs(value))) {
				// If the given date is after or on the current quarter end date, return the current quarter end
				quarterEnd = currentQuarterEnd;
			} else {
				// Otherwise, return the previous quarter end
				const lastQuarterEnd = dayjs(value).subtract(1, 'quarter').endOf('quarter');
				quarterEnd = lastQuarterEnd.format('YYYY-MM-DD');
			}
		}
		return new DateFormatter(this.pattern, this.defaultValue).format(quarterEnd);
	}
}
